<template>
  <div>
    <section-title class="mt-5" has-line title="Información de Vigencia" />
    <div class="row mx-2">
      <div class="col-md-3 col-sm-12">
        <span class="data-label">Año Fiscal:</span>
        <div class="d-flex align-items-center">
          <p class="data">
            {{ value.fiscalYearDescription }}
          </p>
        </div>
      </div>
      <div class="col-md-3 col-sm-12">
        <span class="data-label">Vigencia de Contrato Previo:</span>
        <div class="d-flex align-items-center">
          <p class="data">
            {{ $formatDate(value.orig_EffecteFromDate) }}
            -
            {{ $formatDate(value.orig_EffectiveToDate) }}
          </p>
        </div>
      </div>
      <div class="col-md-3 col-sm-12">
        <validation-provider v-slot="{ errors }" rules="required">
          <div class="data-label">Fecha de Comienzo:</div>
          <custom-date-picker
            v-model="value.effectiveFromDate"
            class="custom-date-picker__extended mt-1"
            :custom-error-msg="errorMsg.dateRequired"
            :disabled="isReadOnly"
            :error="errors[0]"
            :min-date="value.orig_EffectiveToDate"
            :open-date="openDate"
          />
        </validation-provider>
      </div>
      <div class="col-md-3 col-sm-12">
        <validation-provider v-slot="{ errors }" rules="required">
          <div class="data-label">Fecha de Finalización:</div>
          <custom-date-picker
            v-model="value.effectiveToDate"
            class="custom-date-picker__extended mt-1"
            :custom-error-msg="errorMsg.dateRequired"
            :disabled="isReadOnly"
            :error="errors[0]"
            :min-date="value.orig_EffectiveToDate"
            :open-date="openDate"
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDatePicker from 'custom-date-picker';
import SectionTitle from 'SectionTitle';
import moment from 'moment';

export default {
  name: 'ValidityInformation',
  components: {
    CustomDatePicker,
    SectionTitle,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        orig_EffecteFromDate: null,
        orig_EffectiveToDate: null,
        effectiveFromDate: null,
        effectiveToDate: null,
      }),
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      errorMsg: {
        dateRequired: 'Fecha Requerida',
      },
    };
  },
  computed: {
    openDate() {
      if (!this.value.orig_EffectiveToDate) return;

      return moment(this.value.orig_EffectiveToDate)
        .add(1, 'days')
        .toDate();
    },
  },
};
</script>

<style scoped lang="scss">
.custom-date-picker__extended ::v-deep {
  .custom-datetime-picker {
    position: absolute !important;
  }
}
</style>
